// i18n area 'storage' — locale lv-LV (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.lv-LV.meta.json.
import type { enUS } from './storage'

export const lvLV: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Izveidot storage',
      path: 'Ceļš',
      pathHint: 'Absolūts ceļš zem atļautas saknes (noklusējums /var/lib/tvirt/pools/)',
      shared: 'Koplietots storage',
      sharedChip: 'koplietots',
      sharedVerifiedChip: 'koplietots · pārbaudīts',
      sharedVerifiedTooltip: 'Koplietošana pārbaudīta: krusteniskās zondes apstiprina, ka katrs dalībnieks redz pārējo rakstītos datus.',
      sharedDisputedChip: 'koplietots · NAV pārbaudīts',
      sharedDisputedTooltip: 'Koplietošana NAV pārbaudīta',
      sharedDisputedPair: '{observer} neredz datus, ko rakstījis {writer}',
      sharedHint: 'Tīkla share, kas uz katra dalībnieka lokāli montēts vienā un tajā pašā ceļā — live migration priekšnosacījums (deklaratīvs).',
      sharedDanger: 'BĪSTAMI — TVirt TIC šim karodziņam: to ieslēdzot, katrs dalībnieks pieņem, ka šajā ceļā redz TOS PAŠUS baitus. Uz mapes, kas patiesībā NAV koplietots share (NFS/CIFS/klastera failu sistēma), rezultāts ir datu bojājums un zudums jau pirmajā migrācijā vai pirmajā HA pārstartēšanā uz cita mezgla. Jāieslēdz tikai tad, ja ceļš ir share, kas identiski montēts uz katra mezgla.',
      type: 'Tips',
      capacity: 'Kapacitāte',
      provisioned: 'Piešķirts',
      provisionedOvercommit: 'Iespējamās saistības pāri kapacitātei: thin sējumi var izaugt līdz {n} GiB.',
      phase: { ready: 'Gatavs', degraded: 'Degradēts', error: 'Kļūda' },

      // Kārta #156 (standarta dialogs): PILNS detaļu dialogs — cilnes,
      // konfigurācijas rindas katram draiverim un novērotā virsma.
      tabConfig: 'Konfigurācija',
      tabCapacity: 'Kapacitāte un stāvoklis',
      cardIdentity: 'Identitāte',
      cardPlacement: 'Izvietojums',
      cardConnection: 'Savienojums',
      usedReal: 'Reālais aizņēmums',
      capacityUnknown: 'Mezgls vēl nav paziņojis šī pūla kapacitāti — šeit skaitļi netiek izdomāti',
      overcommitHint: 'Saistības pāri kapacitātei: uz thin pūliem tas ir likumīgi, jāseko reālajam aizņēmumam',
      supportedContent: 'Atbalstītais saturs',
      content: {
        disks: 'Diski',
        catalogFiles: 'Kataloga faili',
        backups: 'Dublējumi',
        appVolumes: 'Lietotņu sējumi'
      },
      defaultDiskFormat: 'Noklusējuma diska formāts',
      reserveGiB: 'Rezervētā brīvā vieta (GiB)',
      available: 'Pieejams',
      diskCount: 'Diski',
      filesystem: 'Failu sistēma',
      observedAt: 'Novērots',
      lostAtRow: 'Pasludināts par zaudētu',
      sharedProbeRow: 'Koplietošanas pārbaude',
      sharedProbeNodes: 'Zondētie mezgli',
      reachableFrom: 'Deklarētā sasniedzamība',
      reachableFromHint: 'Mezgli, no kuriem šim storage jābūt sasniedzamam. VM, kurai šeit ir diski, ISO vai metadati, nestartē un nemigrē uz mezglu ārpus šī saraksta. Visi dalībnieki ir iepriekš atlasīti: sarakstu var sašaurināt pēc vajadzības. Mezgls, kas klasterī iestājas vēlāk, paliek ārpusē, kamēr nav pievienots šeit.',
      reachableFromNone: 'nav deklarēta',
      reachableFromTags: 'Sasniedzamība pēc taga',
      reachableFromTagsHint: 'Selektors tags=vērtība (ieraksti atdalīti ar komatu, saistīti ar UN): katrs dalībnieks, kas nes šos tagus, tiek deklarēts par sasniedzamu — dinamiski: piešķirot mezglam tagu, tas nonāk iekšā.',
      reachableFromTagsInvalid: 'Nederīgs formāts — jālieto tags=vērtība, atdalīti ar komatu',
      reachableResolved: 'Atrisinātie mezgli: {nodes}',
      reachableDeclaredNotSeen: 'deklarēts, bet koplietošanas zonde to neredz uz: {nodes}',
      reachableSeenNotDeclared: 'redzēts, bet nav deklarēts (ārpus perimetra) uz: {nodes}',
      cephCluster: 'Pārvaldītais Ceph klasteris',
      appGuardTitle: 'Lietotņu izmantotais storage',
      appEphemeralGuard: 'šis storage ir klastera Lietotņu īslaicīgais pūls — vispirms tas jāmaina Lietotņu lapā, tikai tad jādzēš.',
      appInUseGuard: 'šeit mīt lietotņu root un sējumi: {apps} — vispirms tie jāpārvieto vai jādzēš.',
      releaseRequiredTitle: "Dzēst '{name}' un atbrīvot tā attēlus?",
      releaseRequiredBatchTitle: 'Dzēst atlasītos storage un atbrīvot to attēlus?',
      releaseRequiredBody: 'Attēlu atbrīvošana nedzēš NEVIENU baitu: reģistrācijas atcelšana atstāj namespace uz diska, attēli vienkārši vairs nav materializēti un katra scope atsauce izdzīvo kā claim — reģistrējiet pool no jauna, un tie tiek atkal adoptēti.',
      releaseConfirm: 'Dzēst un atbrīvot attēlus'
    },
    lost: {
      chip: 'Zaudēts',
      action: 'Pasludināt par zaudētu',
      confirmTitle: 'Pasludināt storage par zaudētu',
      confirmBody: 'Operatora apliecinājums uz paša deklarētu risku: katrs rindā vai izpildē esošs task uz šī storage vai tā objektiem NEIZDOSIES, dzēšanas kļūst tikai reģistra līmeņa (nekāda darba failu sistēmā), un jauns fizisks darbs tiek noraidīts. Baiti netiek aiztikti nekad — ja sējums atgriežas dzīvē, tas jāreģistrē no jauna un jāizpilda skenēšana, lai visu adoptētu atpakaļ.',
      confirmSubmit: 'Pasludināt par zaudētu',
      error: 'Apliecinājums tika noraidīts'
    },
    findings: {
      action: 'Atrastie objekti',
      title: 'Atrastie objekti',
      empty: 'Storage namespace nav atrasts neviens objekts',
      loadError: 'Neizdevās ielādēt atrastos objektus',
      actionError: 'Lēmums tika noraidīts',
      colKind: 'Tips',
      colObject: 'Objekts',
      colConflict: 'Konflikts',
      namespaceNotice:
        'Šis katalogs jau bija inicializēts ar citu krātuvi: identitātes zīmogs ir pārrakstīts ar šīs krātuves zīmogu. Saturs NAV aiztikts — apskati zemāk atrastos objektus, importē vajadzīgos un tad noraidi šo paziņojumu.',
      kind: {
        disk: 'Disks',
        catalogFile: 'Kataloga fails',
        vmMetadata: 'VM metadati',
        namespace: 'Namespace',
        foreign: 'Svešs',
        volumeGroup: 'Sējumu grupa'
      },
      vgAdopt: {
        action: 'Adoptēt sējumu grupu',
        title: 'Adoptēt sējumu grupu',
        intro:
          'Šī ierīce jau nes sējumu grupu ar TVirt nosaukumu, bet tās zīmogs nenosauc nevienu šeit reģistrētu storage. Tas var būt tas, ko ŠĪ klastera iepriekšējais storage atstāja uz LUN, vai tas, ko CITS TVirt klasteris atstāja uz LUN, kas mainījis īpašnieku: no šejienes abi gadījumi izskatās identiski, un tāpēc neviens nelemj tavā vietā.',
        irreversible: 'Apskati ierīci, zīmogu un nosaukumu pirms turpināšanas: adopciju nevar atsaukt.',
        device: 'Ierīce',
        seal: 'Zīmogs',
        sealNone: 'nav (nav tvirt.storageId taga)',
        renameTo: 'Tiks pārdēvēta par',
        renameNone: 'Bez pārdēvēšanas: nosaukums jau ir tas, ko šis storage atvasina',
        volumesNote:
          'Tajā esošie sējumi ar šo žestu NETIEK adoptēti: nākamā skenēšana tos piedāvās pa vienam kā parastus atrastos objektus.'
      },
      conflictChip: 'ID jau pastāv',
      dismissedChip: 'Ignorēts',
      adopt: 'Adoptēt',
      adoptFileTitle: 'Importēt katalogā',
      adoptFileHint: 'Faili pastāv tikai katalogos: atrastajam failam jāizvēlas mērķa katalogs.',
      purge: 'Dzēst no diska',
      dismiss: 'Ignorēt',
      purgeConfirmTitle: 'Dzēst no diska',
      purgeConfirmBody: 'Atrastie {id} baiti tiks noņemti no storage. Darbība nav atgriezeniska.',
      taskStarted: 'Sākts — turpinās kā fona task',
      scan: 'Skenēt storage',
      scanStarted: 'Skenēšana sākta…',
      scanDone: 'Skenēšana pabeigta — atrastie objekti ir atjaunināti'
    },
    reinit: {
      action: 'Mēģināt inicializāciju vēlreiz'
    },
    wizard: {
      addButton: 'Pievienot',
      title: 'Pievienot storage',
      back: 'Atpakaļ',
      continue: 'Turpināt',
      selectHint: 'Jāizvēlas protokols, lai redzētu, kā TVirt to lieto.',
      roadmap: 'Attīstības plāns',
      server: 'Serveris',
      export: 'Eksportētais ceļš',
      share: 'Share',
      username: 'Lietotājvārds',
      password: 'Parole',
      passwordHint: 'Tikai rakstīšanai: izmantota montēšanai, vairs nekad netiek rādīta.',
      credential: 'Akreditācijas dati',
      credentialManual: 'Ievadīt manuāli',
      credentialHint: 'Keystore ieraksts ar lietotājvārdu un paroli — alternatīva to ievadīšanai šeit.',
      credentialEmpty: 'Keystore nav nevienu akreditācijas datu ar lietotājvārdu un paroli — tie jāizveido sadaļā Sistēma → Akreditācijas dati vai arī konts jāievada zemāk.',
      options: 'Montēšanas opcijas',
      optionsHint: 'Atdalītas ar komatu, tiek padotas mount -o tādas, kādas ir.',
      portal: 'Portal',
      portalHint: 'host[:ports] — noklusējuma ports ir 3260.',
      target: 'Target IQN',
      targetHint: 'iSCSI target nosaukums, sākas ar iqn.',
      lun: 'LUN',
      wholeLunRow: 'Uz diskiem: šī krātuve nosauc tikai target',
      wholeLunHint: 'Šī krātuve nosauc tikai target: tās LUN kļūst par diskiem pa vienam (Izveidot disku → pārņemt visu LUN), uz target nekas netiek rakstīts.',
      lunHint: 'LUN numurs uz target — šaubu gadījumā 0.',
      chapCredential: 'Akreditācijas dati (CHAP)',
      chapCredentialHint: 'Keystore ieraksts ar tipu CHAP (iSCSI), izmantots pieteikšanās brīdī — noslēpums nekad neceļo līdzi storage.',
      chapNone: 'Bez autentifikācijas',
      chapEmpty: 'Keystore nav nevienu CHAP (iSCSI) tipa akreditācijas datu — tie jāizveido sadaļā Sistēma → Akreditācijas dati. Bez tiem pieteikšanās paliek neautentificēta.',
      address: 'Adrese',
      addressHint: 'NVMe/TCP target hosts vai IP (traddr).',
      port: 'Ports',
      portHint: 'Target TCP ports — 4420, ja atstāts tukšs.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'Subsistēmas NQN uz target, sākas ar nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID subsistēmas iekšienē — šaubu gadījumā 1.',
      dhchapCredential: 'Akreditācijas dati (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Keystore ieraksts ar tipu DH-HMAC-CHAP (NVMe), izmantots savienojuma brīdī — noslēpums nekad neceļo līdzi storage.',
      dhchapNone: 'Bez autentifikācijas',
      dhchapEmpty: 'Keystore nav nevienu DH-HMAC-CHAP (NVMe) tipa akreditācijas datu — tie jāizveido sadaļā Sistēma → Akreditācijas dati. Bez tiem savienojums paliek neautentificēts.',
      monitors: 'Monitori',
      monitorsHint: 'Ceph monitoru galapunkti, host[:ports], atdalīti ar komatu vai jaunu rindu — noklusējuma ports 6789.',
      pool: 'Pūls',
      poolHint: 'Izmantojamais RBD pūls — viens RBD attēls katram diskam.',
      fs: 'Failu sistēma',
      fsHint: 'CephFS failu sistēmas nosaukums (mds_namespace montēšanas brīdī).',
      fsPath: 'Ceļš failu sistēmas iekšienē',
      fsPathHint: 'Absolūts ceļš failu sistēmā, ko storage montē — šaubu gadījumā /.',
      cephxCredential: 'Akreditācijas dati (cephx)',
      cephxCredentialHint: 'Keystore ieraksts ar tipu cephx: lietotājvārds = klienta nosaukums (client.…), noslēpums = base64 atslēga. Obligāti.',
      cephxNone: 'Keystore nav nevienu cephx akreditācijas datu — tie jāizveido (tips: cephx) sadaļā Sistēma → Akreditācijas dati, vai arī jāļauj pārvaldītam Ceph klasterim tos izkalt ar darbību "Piedāvāt kā storage".',
      sharedByNature: 'Tīkla storage pēc savas dabas ir koplietoti: katrs dalībnieks tos montē vienā un tajā pašā TVirt pārvaldītajā ceļā.',
      error: 'Storage tika noraidīts',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Cits',
        legacy: 'Legacy'
      },
      legacyHint: 'Pilnvērtīgi atbalstīti — vienkārši jaunai instalācijai mēs tos neizvēlētos.',
      proto: {
        // Rinda `usage` (Luca 2026-07-24) pasaka, kā TVirt lieto protokolu —
        // pirmām kārtām atļautos saturus: dir/nfs/cifs mitina diskus UN
        // ISO/disku attēlus un template, bloku draiveri (iscsi/nvme-tcp/rbd)
        // TIKAI diskus.
        dir: {
          name: 'Lokāla mape',
          desc: 'Mezgla direktorija: vienkārši un ātri. Tā ir LOKĀLA vienam mezglam, ja vien ceļš nav patiesi koplietots share — atzīmēt to par koplietotu, kad tas tāds nav, maksā datus.',
          usage: 'TVirt tajā glabā VM diskus, ISO un disku attēlus un template.'
        },
        nfs: {
          name: 'NFS',
          desc: 'NFS eksports, ko montē klasteris — koplietots pēc savas dabas.',
          usage: 'Mitina VM diskus, ISO un disku attēlus un template.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Windows/Samba share, ko montē klasteris — koplietots pēc savas dabas.',
          usage: 'Mitina VM diskus, ISO un disku attēlus un template.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Attāla failu sistēma caur SSH — bez vajadzības pēc NAS eksporta.',
          usage: 'Attīstības plānā.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Bloku LUN caur IP ar koplietotu LVM virsū.',
          usage: 'Tikai diski — viens thin sējums katram diskam; nemitina ne ISO attēlus, ne template.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Bloku ierīces, izkliedētas Ceph klasterī.',
          usage: 'Tikai diski — viens RBD attēls katram diskam, ko QEMU atver natīvi; nemitina ISO attēlus.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Ceph izkliedētā failu sistēma, ko klasterī montē kodols — shared by nature.',
          usage: 'Mitina VM diskus, ISO un disku attēlus un template — dir saime uz Ceph failu sistēmas (cephx akreditācijas dati obligāti).'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI LUN uz FibreChannel fabric — klasiskais FC SAN.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Tas pats SCSI uz FibreChannel, ar FC kadriem, iekapsulētiem Ethernet.' },

        // Dzīvs kopš kārtas #132 — atslēga ir contract draivera nosaukums,
        // tā storage saraksta čipss atrisina to pašu ierakstu.
        'iscsi-lun': {
          name: 'iSCSI (visi LUN)',
          desc: 'iSCSI target kā visu LUN nesējs: katrs disks IR LUN, nodots viesim neapstrādāts — bez LVM pa vidu.',
          usage: 'Tikai diski — viens viss LUN uz disku, pārņemts tāds, kāds ir; koplietotas rakstīšanas disku SAN mājas.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (visi namespace)',
          desc: 'NVMe apakšsistēma kā visu namespace nesēja: katrs disks IR namespace, nodots viesim neapstrādāts.',
          usage: 'Tikai diski — viens viss namespace uz disku, pārņemts tāds, kāds ir; koplietota rakstīšana jā, SCSI persistent reservations nē.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Attāls NVMe — bez SCSI ceļā — uz vienkārša TCP, ar koplietotu LVM virsū.',
          usage: 'Tikai diski — viens thin sējums katram diskam; nemitina ne ISO attēlus, ne template.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Attāls NVMe uz FibreChannel fabric.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe uz FibreChannel fabric, ko FCoE nes Ethernet iekšienē — FCoE un NVMe/FC slāņi, sakrauti viens uz otra.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI ar datu ceļu, pārceltu uz RDMA — jebkurš fabric (InfiniBand, iWARP, RoCE). Aizstāts ar NVMe/RDMA, joprojām sastopams masīvos un ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Natīvs SCSI uz RDMA, pirms-iSER laikmets: InfiniBand (ar fabric discovery) un RoCE — izdzīvo novecojušos HPC storage.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Attāls NVMe uz jebkura RDMA fabric — InfiniBand, iWARP, RoCE v1 un v2: viena vienīga konfigurācija, mezgls pats pasaka, kurš tam ir.' },
        s3: { name: 'S3', desc: 'Ar S3 saderīgs objektu storage — attēli un backup.' }
      }
    },
    catalogs: {
      title: 'Katalogi',
      createTitle: 'Izveidot katalogu',
      editTitle: 'Rediģēt katalogu',
      docTitle: 'Katalogs',
      notFound: 'Šis katalogs (vairs?) nepastāv',
      scopeHint: 'Kas lasa šo scope, redz (un var lietot) katru kataloga failu',
      files: 'Faili',
      noFiles: 'Nav failu',
      count: {
        iso: 'ISO',
        ctRootfs: 'CT tpl',
        vmTemplate: 'VM tpl',
        ociImage: 'OCI',
        firmwareOvmf: 'Programmaparatūra'
      },

      // Sistēmas katalogs (kārta #126): platformas iebūvēto objektu mājvieta —
      // lasāms visiem, rakstāms nevienam.
      systemChip: 'sistēmas',
      systemTooltip: 'Sistēmas katalogs: mitina platformas iebūvētos objektus un nav maināms'
    },

    // Kataloga faili (kārta K1, inventory v2e/v2g): katalogs ir klastera failu
    // artefaktu mājvieta — viens saraksts, virsraksti pēc kind.
    catalogFiles: {
      catalog: 'Katalogs',
      kindLabel: 'Tips',
      physicalSize: 'Fiziskais izmērs',
      virtualSize: 'Virtuālais izmērs',

      // Kārta K3 (#64) + K4 (#65, ova/ovf ar boot-survival kartējumu):
      // materializē vm-template failu kā inventāra VM Template.
      importTemplateAction: 'Importēt kā VM Template',
      importTemplateLegacy: 'Nav deklarēts formāts — lietojams kā sēkla diskiem, nav importējams',
      importTemplateTitle: 'Importēt kā VM Template',
      importTemplateSubmit: 'Importēt',
      importTemplateError: 'Imports neizdevās',
      importTemplateHint: 'Pakotne .tvtpl kļūst par VM Template: manifestā iesaldētā aparatūra plus viens disks katram arhīva ierakstam, katrs pārbaudīts pret savu kontrolsummu. NIC un CD/DVD datu nesēji nav arhīva daļa — tie jāpievieno pēc importa.',
      importTemplateQcow2Hint: 'Kails qcow2 kļūst par VIENA diska template ar deklarēto noklusējuma aparatūru: linux profils, UEFI, 2 vCPU, 2048 MiB, sāknēšana no tā vienīgā diska. Jāizlabo izvietošanas brīdī.',
      importTemplateName: 'Template nosaukums',
      importTemplateNameHint: 'Tukšs = {name} (-import-<n>, ja aizņemts)',
      importTemplateStorage: 'Storage diskiem',
      importTemplateMetadataStorage: 'Metadatu storage',
      importTemplateMetadataHint: 'Bloku storage nemitina VM metadatus (programmaparatūra, varstore) — jāizvēlas dir/nfs/cifs.',
      importTemplateStarted: 'Imports sākts — template parādās cilnē Template, kad task noslēdzas.',

      // Runīgas etiķetes vienskaitlī (#86): atrastie objekti un uzskaitījums
      // pasaka, KAS ir fails — vispārīgais 'Kataloga fails' paliek tikai kā
      // rezerves variants.
      kind: {
        iso: 'ISO attēls',
        'ct-rootfs': 'CT rootfs',
        'vm-template': 'VM template',
        'oci-image': 'OCI attēls',
        'firmware-ovmf': 'OVMF programmaparatūra'
      },
      title: {
        iso: 'ISO attēli',
        'ct-rootfs': 'CT template',
        'vm-template': 'VM template',
        'oci-image': 'OCI attēli',
        'firmware-ovmf': 'OVMF programmaparatūra'
      },
      createTitle: {
        iso: 'Pievienot ISO attēlu',
        'ct-rootfs': 'Reģistrēt CT template',
        'vm-template': 'Pievienot VM template',
        'oci-image': 'Pievienot OCI attēlu',
        'firmware-ovmf': 'Pievienot OVMF programmaparatūru'
      },
      formatHint: 'Atvasināts no izvēlētā faila paplašinājuma — jāizlabo, ja uzminēts nepareizi',
      tarballHint: 'Rootfs tarball standarta LXC formātā (.tar.gz / .tar.xz / .tar.zst / .tar.bz2 vai vienkāršs .tar)',
      ociArchiveHint: 'Tarball docker-archive / oci-archive formātā (.tar vai .tar.gz), piemēram, no docker save',
      uploadResumeHint: 'Augšupielāde pārtraukta — fails gaida augšupielādi: jānosūta vēlreiz tas pats fails, lai turpinātu',
      moveTitle: 'Pārvietot failu',
      moveHint: 'Divas neatkarīgas dimensijas: Katalogs pārvieto saiti (tas pats id, neviens baits nepārceļas, scope kļūst par mērķa kataloga scope); Storage pārvieto datus — katra saistītā kopija seko, noraidīts, kamēr fails ir lietošanā. Izvēlēti kopā: vispirms katalogs, tad storage.',
      moveCatalog: 'Mērķa katalogs',
      moveCatalogHint: 'Mājas maina tikai saite: VM, kas failu pievienojusi, jāredz mērķa katalogs',
      keepCurrent: 'Nemainīt',
      rehomed: 'Saite pārvietota uz izvēlēto katalogu',
      copyAction: 'Kopēt katalogā…',
      copyTitle: 'Kopēt katalogā',
      copyLinkHint: 'Kopija ir jauna saite uz tiem pašiem datiem — storage nekas netiek dublēts.',
      copyCatalog: 'Mērķa katalogs',
      copyCatalogHint: 'Kopēšana ir veids, kā fails pārceļo starp katalogiem',
      sameCatalog: 'Tas pats, kas avotam',
      sharedObjectHint: 'Šī faila datus koplieto {count} saistītas kopijas',
      deleteLastLink: 'Šī ir PĒDĒJĀ saite uz šo saturu: tiks dzēsti arī dati no storage.',
      deleteLinkOnly: 'Tiks noņemta tikai šī saite — dati paliek, joprojām sasniedzami no pārējām saistītajām kopijām ({count}).',
      noCatalog: 'Nav neviena kataloga — jāizveido kāds',
      inlineCatalogName: 'Kataloga nosaukums',

      // Platformā iebūvētie faili (kārta #126): storage null — tos lasa un
      // klonē, nekad nepārvieto, nedzēš un nepārdēvē.
      embeddedChip: 'iebūvēts',
      embeddedStorage: 'Iebūvēts platformā',
      embeddedNoMove: 'Platformas iebūvēts fails: tas nemīt nevienā storage — tā vietā jāklonē',
      embeddedCopyHint: 'Klons materializē iebūvētos baitus īstā storage: jāizvēlas mērķa storage un katalogs — kopija ir parasts fails',
      sourceEmbedded: 'Iebūvēts platformā',
      nodesRow: 'Klātbūtne pa mezgliem',
      nodesSummary: '{present} no {total} mezgliem tas ir',
      nodePresent: 'ir',
      nodeMissing: 'trūkst',
      nodeUnknown: 'vēl nav ziņots',
      nodesHint: 'Resurss atrodas katra mezgla diskā (pakotne trantor-tvirt-assets): mezgls bez tā nevar ne definēt VM ar šo programmaparatūru, ne nodrošināt Guest Tools. Dažādas versijas starp mezgliem ir normālas pakāpeniskas atjaunināšanas laikā.',

      // Lejupielāde (kārta #108): baiti ceļo ar savu atsevišķo atļauju.
      downloadAction: 'Lejupielādēt',
      downloadNotReady: 'Saturs vēl nav gatavs — lejupielādei nepieciešams ready fails',
      downloadDenied: 'Jūsu lomā nav iekļauta catalog.download — baitu lejupielāde ir no faila lietošanas atsevišķas tiesības',

      // Kārta #156 (standarta dialogs): trūkstošās detaļu dialoga lasīšanas
      // rindas — koplietotā objekta fakti, deklarētā kontrolsumma un
      // izmantotāji.
      objectRow: 'Storage objekts',
      objectLinksRow: 'Saistītās kopijas',
      declaredChecksum: 'Deklarētais SHA-256',
      usedByRow: 'Lieto',
      usedByVms: 'VM',
      usedByDisks: 'Diski',
      transferRow: 'Pārsūtīšana',
      storageLockHint: 'Mainās tikai ar darbību Pārvietot'
    },

    // Uzskaitījums katram storage (kārta K1, inventory v2b #2): tikai lasāms,
    // katrs objekts pārvaldāms savā sadaļā.
    objects: {
      action: 'Pārlūkot saturu',
      title: 'Storage saturs',
      hint: 'Tikai lasāms uzskaitījums par to, kas mīt šajā storage — katrs objekts pārvaldāms savā sadaļā.',
      empty: 'Šajā storage nav reģistrēts neviens objekts',
      loadError: 'Neizdevās ielādēt saturu',
      colDetail: 'Detaļas',
      manage: 'Pārvaldīt savā sadaļā',
      kind: {
        disk: 'Disks',
        catalogFile: 'Kataloga fails',
        ociBlob: 'OCI blobs',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM metadati',
        appRoot: 'Lietotnes root',
        appVolume: 'Lietotnes sējums'
      }
    },
    inventory: {
      tabCatalogs: 'Katalogi',
      storage: 'Storage',
      sizeGib: 'Izmērs (GiB)',
      format: 'Formāts',
      size: 'Izmērs',
      sourceType: 'Avots',
      sourceFile: 'Faila augšupielāde',
      sourceUrl: 'Lejupielāde no URL',
      file: 'Fails',
      url: 'URL',
      checksum: 'Kontrolsumma SHA-256',
      checksumHint: 'Obligāta: lejupielāde tiek pārbaudīta pret šo SHA-256',
      verifyChecksum: 'Pārbaudīt kontrolsummu',
      checksumOffHint: 'Lejupielāde tiks pieņemta bez pārbaudes — aprēķinātais SHA-256 tik un tā tiek reģistrēts',
      uploading: 'Notiek augšupielāde…',
      move: {
        action: 'Pārvietot',
        diskTitle: 'Pārvietot disku',
        target: 'Mērķa storage',
        diskHint: 'Disks saglabā savu identitāti: baiti pārceļas uz izvēlēto storage. VM, kas to lieto, jābūt izslēgtai; ja ir snapshot, iSCSI puse pārvietošanu noraida.',
        noTargets: 'Nav neviena saderīga mērķa storage',
        submit: 'Pārvietot',
        error: 'Pārvietošana tika noraidīta'
      },
      clone: {
        action: 'Klonēt',
        title: 'Klonēt disku',
        name: 'Kopijas nosaukums',
        storage: 'Mērķa storage',
        sameStorage: 'Tas pats, kas avotam',
        linked: 'Linked clone',
        linkedHint: 'Momentāns qcow2 overlay, sasaistīts ar avota disku (tikai qcow2 avotiem). Noklusējums ir pilna kopija.',
        linkedCrossHint: 'Linked clone paliek avota storage: lai to iespējotu, jāizvēlas "Tas pats, kas avotam".',
        submit: 'Klonēt',
        error: 'Klonēšana tika noraidīta'
      },
      copy: {
        action: 'Kopēt',
        name: 'Kopijas nosaukums',
        storage: 'Mērķa storage',
        sameStorage: 'Tas pats, kas avotam',
        submit: 'Kopēt',
        error: 'Kopēšana tika noraidīta'
      },
      taskStarted: 'Sākts — turpinās kā fona task',
      cephObjects: 'Doties uz objekta detaļām Ceph',
      phase: {
        ready: 'Gatava',
        creating: 'Notiek izveide',
        'awaiting-upload': 'Gaida augšupielādi',
        downloading: 'Notiek lejupielāde',
        verifying: 'Notiek pārbaude',
        deleting: 'Notiek dzēšana',
        error: 'Kļūda',
        'in-use': 'Lietošanā'
      }
    }
  }
}
